import React, { useState } from 'react';
import { Select, Empty, Icon, Card, Tabs, Row, Col } from 'antd';
import parse from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons';
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import CustomAvatar from './../components/customAvatar';
import { navigate } from "@reach/router"
import { nameStyle, roleStyle } from './../theme';
import ContactEventsList from './../components/contactEventsList';
import { EVENT_TYPE } from './../utils';

const { orderBy } = require('lodash');
const { TabPane } = Tabs;
const { Option } = Select;

function ContactDetail(props) {
  const contact = props.data;

  const eventsTypeArr = orderBy(Object.keys(EVENT_TYPE).map(e => {
    return EVENT_TYPE[e]
  }));

  const [eventType, setEventType] = useState(EVENT_TYPE.all.name);

  const eventTypeSelection = [];
  for (let i = 0; i < eventsTypeArr.length; i++) {
    eventTypeSelection.push(
      <Option key={eventsTypeArr[i].name} value={eventsTypeArr[i].name}>
        {eventsTypeArr[i].text}
      </Option>
    )
  }

  const getEvents = (eventType, data) => {
    let events = data;
    if (eventType !== 'all') {
      events = data.filter(i => i.type === eventType)
    }
    return events
  }

  const cardTitle = (contact) => {
    return(
      <center>
        <CustomAvatar
          colourCode={contact.firstname.charAt(0).toLowerCase()}
          char={`${contact.firstname.charAt(0).toUpperCase()}${contact.lastname.charAt(0).toUpperCase()}`}
          charSize={30}
          size={86}
          src={contact.avatar}
        />

        <div style={{marginTop: "15px"}}>
          <p style={nameStyle}>
            {contact.salutation} {contact.firstname} {contact.lastname}
          </p>

          <p style={roleStyle} onClick={() => {
            navigate(`/clients/${contact.client.id}`);
          }}>
            <span style={{cursor: "pointer"}}>{contact.client.name}</span>
          </p>

          {
            contact.linkedin && contact.linkedin !== "" ?
            <React.Fragment>
            <br/>
            <p style={roleStyle} onClick={() => {
              window.open(contact.linkedin, '_blank');
            }}>
              <span style={{cursor: "pointer"}}>go to linkedin</span>
            </p>
            </React.Fragment>
            :
            null
          }
        </div>
      </center>
    )
  }

  return (
    <Row style={{
      maxHeight: '400px',
      overflow: 'auto'
    }}>
      <Col span={6}>
        <div style={{marginRight: '5px'}}>
          <Card title={cardTitle(contact)} bordered={true}>
            <div style={{marginTop: '-25px'}}>
              {
                contact.dob && contact.dob !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b></div>
                  <div>{moment(contact.dob).format('YYYY-MM-DD')}</div>
                </React.Fragment>
                :
                null
              }

              {
                contact.email !== "" || contact.email1 !== "" || contact.email2 !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="mail" theme="filled" /> <b>Email</b></div>
                  {
                    contact.email !== "" ?
                    <div>{contact.email}</div>
                    :
                    null
                  }
                  {
                    contact.email1 !== "" ?
                    <div>{contact.email1}</div>
                    :
                    null
                  }
                  {
                    contact.email2 !== "" ?
                    <div>{contact.email2}</div>
                    :
                    null
                  }
                </React.Fragment>
                :
                null
              }

              {
                contact.department && contact.department !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faBuilding} /> <b>Department</b></div>
                  <div>{contact.department}</div>
                </React.Fragment>
                :
                null
              }

              {
                contact.position && contact.position !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="idcard" theme="filled" /> <b>Position</b></div>
                  <div>{contact.position}</div>
                </React.Fragment>
                :
                null
              }

              {
                contact.tel && contact.tel !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="phone" theme="filled" /> <b>Landline</b></div>
                  <div>{contact.tel}</div>
                </React.Fragment>
                :
                null
              }

              {
                contact.mobile && contact.mobile !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="mobile" theme="filled" /> <b>Mobile</b></div>
                  <div>{contact.mobile}</div>
                </React.Fragment>
                :
                null
              }

              {
                contact.wechat && contact.wechat !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="wechat" theme="filled" /> <b>Wechat</b></div>
                  <div>{contact.wechat}</div>
                </React.Fragment>
                :
                null
              }

              {
                contact.whatsapp && contact.whatsapp !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faPhoneVolume} /> <b>Whats App</b></div>
                  <div>{contact.whatsapp}</div>
                </React.Fragment>
                :
                null
              }

              {
                contact.othercontact && contact.othercontact !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faExclamationCircle} /> <b>Other Contact</b></div>
                  <div>{contact.othercontact}</div>
                </React.Fragment>
                :
                null
              }

            </div>
          </Card>
        </div>
      </Col>

      <Col span={18}>
        <Tabs type="card">
          <TabPane tab="Events" key="events">

            <Row>
              <Col span={8}>
                <div>
                  <Select
                    value={eventType}
                    style={{ width: 220 }} onChange={(value) => {setEventType(value)}}
                  >
                  {eventTypeSelection}
                  </Select>
                </div>
              </Col>
            </Row>
            <br/>

            <ContactEventsList
              contactID={contact.id}
              data={getEvents(eventType, contact.events)}
              disableRemove={true}
            />
          </TabPane>
          <TabPane tab="Notes" key="notes">
          {
            contact.notes && contact.notes !== "" ?
              parse(contact.notes)
            :
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          }
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  );
}

export default ContactDetail;
